<app-modal
  [(open)]="dropZone.showConfirmModal"
  title="Gider Yükleme"
  subtitle="Bu dosyaları gider olarak yüklemek istiyor musunuz?"
  acceptLabel="Yükle"
  rejectLabel="Vazgeç"
  [acceptDisabled]="isEmpty()"
  (accept)="onConfirm()"
  maxWidth="36rem"
>
  <svg modalIcon fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>

  <div class="jl-ucm-file-list">
    @for (preview of filePreviews(); track preview.name; let i = $index) {
      <div class="jl-ucm-file-row">
        <div class="jl-ucm-file-thumb">
          @if (preview.isImage && preview.objectUrl) {
            <img [src]="preview.objectUrl" [alt]="preview.name" class="jl-ucm-file-img" />
          } @else {
            <div class="jl-ucm-file-icon">
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
              <span class="jl-ucm-pdf-badge">PDF</span>
            </div>
          }
        </div>

        <div class="jl-ucm-file-info">
          <span class="jl-ucm-file-name" [title]="preview.name">{{ preview.name }}</span>
          <span class="jl-ucm-file-size">{{ preview.size }}</span>
        </div>

        <button type="button" class="jl-ucm-file-remove" (click)="removeFile(i)" title="Kaldır">
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
    }
  </div>

  <button type="button" class="jl-ucm-add-btn" (click)="triggerFileInput()">
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
    Daha fazla dosya ekle
  </button>

  <input
    #fileInput
    type="file"
    multiple
    accept=".pdf,.jpeg,.jpg,.png"
    class="jl-ucm-hidden-input"
    (change)="onFilesSelected($event)"
  />
</app-modal>
